import { useEffect, useState } from "react";

const useIdleTimer = (timeout = 600000) => { // Default timeout: 10 minutes (600000 ms)
  const [isIdle, setIsIdle] = useState(false);
  let timer;

  const resetTimer = () => {
    clearTimeout(timer);
    setIsIdle(false);
    timer = setTimeout(() => setIsIdle(true), timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];

    const handleEvent = () => resetTimer();

    events.forEach(event => window.addEventListener(event, handleEvent));

    resetTimer(); // Initialize timer on mount

    return () => {
      clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, handleEvent));
    };
  }, [timeout]);

  return isIdle;
};

export default useIdleTimer;
